import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "icon", "rightIcon", "children", "background", "color", "borderColor", "borderStyle", "borderWidth", "truncate", "shadow", "bold"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { getColorProps, getBackgroundProps, getBorderProps } from './helpers';
import styles from './styles.module.css';

/**
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=33907-23222&node-type=canvas&t=dWJSsCGr4smKrzpW-0)
 * [Новый дизайн](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/branch/erObjfNZ0LXbD3MtYrp2Jm/%F0%9F%8C%90-Web-Components?node-id=59499-4787&m=dev)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Label = /*#__PURE__*/React.forwardRef(function Label(_ref, ref) {
  let {
      className,
      icon,
      rightIcon,
      children,
      background = 'text-secondary-default',
      color = 'decorative-theme-white',
      borderColor,
      borderStyle,
      borderWidth,
      truncate = false,
      shadow = false,
      bold = false
    } = _ref,
    htmlProps = _objectWithoutProperties(_ref, _excluded);
  const isPointer = !!htmlProps.onClick;
  const colorProps = getColorProps(color);
  const backgroundProps = getBackgroundProps(background);
  const borderProps = getBorderProps({
    borderColor,
    borderStyle,
    borderWidth
  });
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({}, htmlProps), {}, {
    ref: ref,
    className: clsx(styles['label'], isPointer && styles['clickable'], truncate && styles['truncate'], shadow && styles['shadow'], bold && styles['bold'], !children && styles['empty'], colorProps.className, backgroundProps.className, borderProps.className, className),
    style: _objectSpread(_objectSpread(_objectSpread({}, colorProps.style), backgroundProps.style), borderProps.style),
    children: [icon && /*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: icon
    }), children && /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: children
    }), rightIcon && /*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: rightIcon
    })]
  }));
});